import {
  ROUTE_BICYCLE_HOME,
  ROUTE_DEPARTMENT_HOME,
  ROUTE_REGION_HOME,
  ROUTE_RESTRICTION_HOME,
  ROUTE_TRAFFIC_HOME,
  ROUTE_ZFE_HOME
} from '../../../../routes'
import { compact } from '../../../../utils/array'
import { generateFullRoute } from '../../../router/routeUtils'
import {
  selectSeoBicycleOptions,
  selectSeoHpLayersBicycle,
  selectSeoHpLayersRestriction,
  selectSeoHpLayersTitle,
  selectSeoHpLayersTraffic,
  selectSeoHpLayersZfe,
  selectSeoInfoTrafficOptions,
  selectSeoRestrictionOptions,
  selectSeoZfeOptions
} from '../seo-footer.selectors'

import seo_bicycle from './seo_bicycle.json'
import seo_restrictions from './seo_restrictions.json'
import seo_traffic from './seo_traffic.json'
import seo_zfe from './seo_zfe.json'

const collectLinks =
  (source = []) =>
  (options = {}) => {
    const { min = 0, max, zip } = options

    if (zip) {
      const itemForLink = source.find(item => item.zip === zip)
      return itemForLink ? [itemForLink] : []
    }

    return source.slice(min, max)
  }

const prefixLink =
  prefix =>
  ({ name, url }) => ({
    label: `${prefix} ${name}`,
    url
  })

export const getTrafficLinks = (options = {}) =>
  collectLinks(seo_traffic)(options).map(prefixLink(options.linksLabel ?? 'Info trafic'))

export const getBicycleLinks = (options = {}) =>
  collectLinks(seo_bicycle)(options).map(prefixLink(options?.linksLabel ?? 'Pistes cyclables'))

export const getZfeLinks = (options = {}) =>
  collectLinks(seo_zfe)(options).map(prefixLink(options?.linksLabel ?? 'ZFE'))

export const getRestrictionLinks = (options = {}) =>
  collectLinks(seo_restrictions)(options).map(prefixLink(options?.linksLabel ?? 'Restrictions de circulation'))

export const getTrafficHpLink = (options = {}) => ({
  label: options?.hpLinkLabel ?? 'Info trafic',
  url: generateFullRoute(ROUTE_TRAFFIC_HOME)
})

export const getBicycleHpLink = (options = {}) => ({
  label: options?.hpLinkLabel ?? 'Plan des pistes cyclables',
  url: generateFullRoute(ROUTE_BICYCLE_HOME)
})

export const getZfeHpLink = (options = {}) => ({
  label: options?.hpLinkLabel ?? "Zone des restrictions Crit'Air",
  url: generateFullRoute(ROUTE_ZFE_HOME)
})

export const getRestrictionHpLink = (options = {}) => ({
  label: options?.hpLinkLabel ?? 'Restrictions de circulation en temps réel',
  url: generateFullRoute(ROUTE_RESTRICTION_HOME)
})

const getZfeTitle = (options = {}) => options?.title ?? 'ZFE en France'

const getRestrictionTitle = (options = {}) => options?.title ?? 'Les restrictions de Circulation en France'

export const buildInfoTrafficLinks = store => {
  const options = selectSeoInfoTrafficOptions(store)
  return {
    title: 'Info-trafic en France',
    contents: compact([getTrafficHpLink(options), ...getTrafficLinks(options)])
  }
}

export const buildBicycleLinks = store => {
  const options = selectSeoBicycleOptions(store)
  return {
    title: 'Pistes cyclables en France',
    contents: compact([getBicycleHpLink(options), ...getBicycleLinks(options)])
  }
}

export const buildZfeLinks = store => {
  const options = selectSeoZfeOptions(store)
  return {
    title: getZfeTitle(options),
    contents: compact([
      getZfeHpLink(options),
      ...getZfeLinks({
        ...options
      })
    ])
  }
}

export const buildRestrictionLinks = store => {
  const options = selectSeoRestrictionOptions(store)
  return {
    title: getRestrictionTitle(options),
    contents: compact([
      getRestrictionHpLink(options),
      ...getRestrictionLinks({
        ...options
      })
    ])
  }
}

export const buildHpLayerLinks = (store, includeZoneLink = false) => {
  const title = selectSeoHpLayersTitle(store)
  const hpLayerTrafficOptions = selectSeoHpLayersTraffic(store)
  const hpLayerBicyclecOptions = selectSeoHpLayersBicycle(store)
  const hpLayerZfeOptions = selectSeoHpLayersZfe(store)
  const hpLayerRestrictionOptions = selectSeoHpLayersRestriction(store)

  const layerLinks = [
    hpLayerTrafficOptions?.visible ? getTrafficHpLink(hpLayerTrafficOptions) : undefined,
    hpLayerBicyclecOptions?.visible ? getBicycleHpLink(hpLayerBicyclecOptions) : undefined,
    hpLayerZfeOptions?.visible ? getZfeHpLink(hpLayerZfeOptions) : undefined,
    hpLayerRestrictionOptions?.visible ? getRestrictionHpLink(hpLayerRestrictionOptions) : undefined
  ]

  const zoneLinks = [
    {
      label: 'Carte des régions françaises',
      url: generateFullRoute(ROUTE_REGION_HOME)
    },
    {
      label: 'Carte des départements français',
      url: generateFullRoute(ROUTE_DEPARTMENT_HOME)
    }
  ]

  const content = includeZoneLink ? layerLinks.concat(zoneLinks) : layerLinks

  return {
    title,
    contents: compact(content)
  }
}
